import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/home.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/questions",
    name: "questions",
    component: () => import(/* webpackChunkName: "questions" */ "../views/questions.vue")
  },
  {
    path: "/generate-codes",
    name: "generate-codes",
    component: () => import(/* webpackChunkName: "generate-codes" */ "../views/generate-codes.vue")
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

export default router
